<div class="mb-3">
  <mat-accordion class="login-faq-accordion">
    @for (item of faqList; track item) {
      <mat-expansion-panel [expanded]="item.isExpanded">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mwp-text-translate [text]="item.title" [jsonKey]="item.jsonKeyTitle" />
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mwp-text-translate [text]="item.body" [jsonKey]="item.jsonKeyBody" [isHTML]="true"></mwp-text-translate>
      </mat-expansion-panel> 
    }
  </mat-accordion>
</div>
<div class="col-12 d-flex justify-content-center">
  <button class="mwp-button-secondary" (click)="closeFAQs()">
    <mwp-text-translate text="Return" jsonKey="return" />
  </button>
</div>